import React from "react";
import * as SlIcons from "react-icons/sl";
import * as FAIcons from "react-icons/fa6";

type ComponentsMap = {
  [key: string]: React.ComponentType<any>;
};

const LIBRARIES: any = {
  fa: FAIcons,
  sl: SlIcons,
};
const Icon = ({ nameIcon, propsIcon, className }: any) => {
  if (!nameIcon) {
    return null;
  }

  const lib = nameIcon
    ?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    ?.split(" ")?.[0]
    ?.toLocaleLowerCase();
  const DynamicComponent = (LIBRARIES[lib] as ComponentsMap)[nameIcon];

  if (DynamicComponent) {
    return <DynamicComponent {...propsIcon} className={className} />;
  } else {
    return null;
  }
};

export default Icon;
